import React, {
  useEffect,
  useRef,
  useState
} from "react";
import CandidatTable from "../Candidat/ListCandidats/CandidatTable/index";
import { withRouter, useLocation } from "react-router-dom";
import qs from "query-string";
import { searchCandidats } from "../Services/CandidatService";
import { ContactList } from "../Contact";
import ListerSociete from "../Societe/ListerSociete";
import { rechercherSociete } from "../Services/SocieteService";
import { searchContacts } from "../Services/ContactService";
import Search from "./search";
import { withSnackbar } from "../../utils/SnackbarHOC";
import { updateObjectStateValue } from "../../utils/FunctionHelpers";
import { Box } from "@material-ui/core";
import { LayoutContainer } from "../../layout/LayoutContainer/LayoutContainer";
import { TABLE } from "../../enums/tablesEnum";
import { getRowsPerPage } from "../../utils/DataTables";
import { advancedSearchIA } from "../Services/SearchService";

const Dashboard = ({
  snackbarShowMessage,
  history
}) => {
  const mounted = useRef(false);
  const aiRequestIdRef = useRef(0);
  const [candidatsData, setCandidatsData] = useState({
    loadCandidats: false,
    pageCandidat: 1,
    candidatsCount: 0,
    candidats: [],
    isLoading: true,
    limit: getRowsPerPage("candidatColumnVisibility") ?? 50,
    sort: {
      name: "prenom",
      direction: "asc",
    }
  });
  const [societesData, setSocietesData] = useState({
    loadSociete: false,
    pageSociete: 1,
    societesCount: 0,
    societes: [],
    isLoading: true,
    limit: getRowsPerPage("societeColumnVisibility") ?? 50,
    sorting: {
      name: "updatedAt",
      direction: "asc",
    }
  });
  const [contactsData, setContactsData] = useState({
    loadContacts: false,
    pageContact: 1,
    contactsCount: 0,
    contacts: [],
    isLoading: true,
    limit: getRowsPerPage("contactColumnVisibility") ?? 50
  });
  const [parameters, setParameters] = useState({});
  const [showTable, setShowTable] = useState(false);
  const [aiMode, setAiMode] = useState(false);
  const [aiRows, setAiRows] = useState({data:[], isLoading: false});
  const location = useLocation();

  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      const params = {};
      for (const [key, value] of searchParams.entries()) {
        params[key] = value;
      }
      handleSearch(params);
    } else {
      handleSearch(parameters);
    }
  }, [location.search])


  const handleSearchCandidats = async (page, params = "", limit = candidatsData.limit) => {
    const isAiSearch = params?.isAiSearch === true || params?.isAiSearch === "true";
    const isAgentIaSearch = isAiSearch && params?.iaMode === "agent";

    if (isAgentIaSearch) {

      aiRequestIdRef.current += 1;
      setAiMode(true);
      setAiRows({ data: [], isLoading: true });
      setCandidatsData((prev) => ({ ...prev, isLoading: false }));
      return;
    }

    if (isAiSearch) {
      const requestId = aiRequestIdRef.current + 1;
      aiRequestIdRef.current = requestId;
      setAiMode(true);
      setAiRows({ data: [], isLoading: true });
      try {
        const searchParams = new URLSearchParams(window.location.search);
        const getArray = (key) =>
            searchParams.getAll(`${key}[]`).filter((v) => v && v.trim() !== "");

        const iaPayload = {};

        const loc = getArray('loc');
        if (loc.length > 0) iaPayload.loc = loc;

        if (params.exclude) iaPayload.exclude = params.exclude;

        const skills = getArray('skills');
        if (skills.length > 0) iaPayload.skills = skills;

        const programming_languages = getArray('programming_languages');
        if (programming_languages.length > 0) iaPayload.programming_languages = programming_languages;

        if (params.role) iaPayload.role = params.role;

        if (params.experience_min || params.experience_max) {
          iaPayload.experience = {};
          if (params.experience_min) iaPayload.experience.min = Number(params.experience_min);
          if (params.experience_max) iaPayload.experience.max = Number(params.experience_max);
        }

        const industry = getArray('industry');
        if (industry.length > 0) iaPayload.industry = industry;

        const res = await advancedSearchIA(iaPayload);

        if (requestId !== aiRequestIdRef.current) return;

        if (res.data?.search_error) {
          snackbarShowMessage(
            "Aucun candidat trouvé pour ces critères. Essayez d'élargir la recherche.",
            "warning",
            5000
          );
          setAiRows({ data: [], isLoading: false });
          setAiMode(true);
          return;
        }

        const candidates = Array.isArray(res.data)
            ? res.data
            : Array.isArray(res.data?.candidates)
                ? res.data.candidates
                : Array.isArray(res.data?.results)
                    ? res.data.results
                    : [];

        setAiRows({ data: candidates, isLoading: false });
        setAiMode(true);
      } catch {
        snackbarShowMessage("Erreur de recherche IA.", "error", 4000);
        setAiRows({ data: [], isLoading: false });
      }
      return;
    }
    aiRequestIdRef.current += 1;
    setAiMode(false);
    setAiRows({ data: [], isLoading: false });

    setCandidatsData((prev) => ({
      ...prev,
      candidats: [],
      loadCandidats: true,
      isLoading: true,
      pageCandidat: page,
      limit
    }));
    try {
      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([key, value]) => value !== "")
      );
      const IA_PARAMS = [
        'isAiSearch', 'iaMode', 'agentText', 'iaForm',
        'loc', 'skills', 'programming_languages',
        'role', 'exclude', 'experience_min', 'experience_max', 'industry'
      ];
      const { ...apiParams } = Object.fromEntries(
          Object.entries(filteredParams).filter(([key]) =>
              !IA_PARAMS.includes(key) && !key.endsWith('[]')
          )
      );
      const queryParams = {
        ...apiParams,
        motsCleCategorie: apiParams.motsCleCategorie || 'tous',
        limit,
      };


      const newCandidats = await searchCandidats(qs.stringify(queryParams, { arrayFormat: "bracket" }), page);
      const candidatsData = {
        loadCandidats: true,
        candidatsCount: newCandidats.data.count,
        candidats: newCandidats.data.candidats,
        isLoading: false,
        pageCandidat: newCandidats.data.page,
        sort: newCandidats.data.sort,
        limit
      };

      updateObjectStateValue(setCandidatsData, candidatsData);
    } catch (error) {
      snackbarShowMessage("Erreur de chargement des candidats.", "error", 4000);
      updateObjectStateValue(setCandidatsData, {
        isLoading: false,
      });
    }
  };


  const handleSearchSocietes = (page, params = "",  limit = societesData.limit) => {
    setSocietesData((prev) => ({
      ...prev,
      loadSociete: true,
      societesCount: 0,
      societes: [],
      isLoading: true,
      pageSociete: 1,
      limit
    }));
    
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([key, value]) => value !== "")
    );
    const queryParams = {
      ...filteredParams,
      limit,
    };

    rechercherSociete(qs.stringify(queryParams), page).then((newSocietes) => {
      setSocietesData((prev) => {
        const sorting = params.column
          ? { column: params.column, direction: params.sort } 
          : prev.sorting;
        return {
          ...prev,
          loadSociete: true,
          societesCount: newSocietes.data.count,
          societes: newSocietes.data.societes,
          isLoading: false,
          pageSociete: newSocietes.data.page,
          sorting,
          limit
        };
      });
    }).catch(error => {
      snackbarShowMessage("Erreur de chargement des sociétés.", "error", 4000);
      setSocietesData((prev) => ({
        ...prev,
        isLoading: false
      }));
    });
  }

  const handleSearchContacts = async (page, params = "", limit = contactsData.limit) => {
    try {
      setContactsData((prev) => ({
        ...prev,
        isLoading: true,
        contactsCount: 0,
        contacts: [],
        pageContact: 1,
        limit
      }));

      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([key, value]) => value !== "")
      );
      const queryParams = {
        ...filteredParams,
        limit,
      };

      const { data } = await searchContacts(qs.stringify(queryParams, { arrayFormat: "bracket" }), page);
      setContactsData((prev) => {
        const sorting = params.column
          ? { column: params.column, direction: params.sort }  // ← source: ce qu'on a envoyé
          : prev.sorting;
        return {
          ...prev,
          loadContacts: true,
          contactsCount: data.count,
          contacts: data.contacts,
          isLoading: false,
          pageContact: data.page,
          limit,
          sorting
        };
      });
    } catch (error) {
      snackbarShowMessage("Erreur de chargement des contacts.", "error", 4000);
      setContactsData({
        isLoading: false
      });
    }
  };


  const candidatProps = {
    candidatsData,
    handleSearchCandidats,
    parameters,
  };

  const contactProps = {
    contactsData,
    handleSearchContacts,
    parameters
  };

  const societeProps = {
    societesData,
    handleSearchSocietes,
    parameters
  };

  const handleSearch = async (params) => {
    setShowTable(true);
    setParameters(params);
    switch (params.categorie) {
      case TABLE.CANDIDAT:
        handleSearchCandidats(candidatsData.pageCandidat, params);
        break;
      case TABLE.SOCIETE:
        handleSearchSocietes(societesData.pageSociete, params);
        break;
      case TABLE.CONTACT:
        handleSearchContacts(contactsData.pageContact, params);
        break;
      default:
        break;
    }
  };

  const handleIaActivate = (payload) => {
    aiRequestIdRef.current += 1;
    setShowTable(true);
    setAiMode(true);
    setAiRows({
      data: payload?.data ?? [],
      isLoading: payload?.isLoading ?? true,
    });
  };

  const handleIaDeactivate = () => {
    aiRequestIdRef.current += 1;
    setAiRows({ data: [], isLoading: false });
    setAiMode(false);
  };

  const searchProps = {
    mounted,
    candidatsData,
    societesData,
    contactsData,
    handleSearch,
    history,
    onIaActivate: handleIaActivate,
    onIaDeactivate: handleIaDeactivate,
    snackbarShowMessage,
  };

  return (
    <LayoutContainer>
      <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            overflowX: "hidden",
          }}
      >
      <Search {...searchProps} />
        <Box
            sx={{
              marginTop: "1rem",
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
        >
        {showTable && parameters.categorie === TABLE.CANDIDAT && <CandidatTable {...candidatProps} aiMode={aiMode} aiRows={aiRows} />}
        {showTable && parameters.categorie === TABLE.CONTACT && <ContactList {...contactProps} />}
        {showTable && parameters.categorie === TABLE.SOCIETE && <ListerSociete {...societeProps} />}
      </Box>
      </Box>
    </LayoutContainer>
  );
};

export default withSnackbar(withRouter(Dashboard));
